package com.hyperether.goodjob.scenes.workspace

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.OutlinedTextField
import androidx.compose.material.TabRowDefaults.Divider
import androidx.compose.material.Text
import androidx.compose.material.TextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import com.hyperether.goodjob.Dp
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.is4K
import com.hyperether.goodjob.isWebMobileView
import com.hyperether.goodjob.models.Workspace
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add_new_workspace
import com.hyperether.goodjob.resources.already_have_workspace
import com.hyperether.goodjob.resources.back_arrow
import com.hyperether.goodjob.resources.click_here
import com.hyperether.goodjob.resources.create
import com.hyperether.goodjob.resources.enter_workspace_name
import com.hyperether.goodjob.resources.error
import com.hyperether.goodjob.resources.logo_good_job
import com.hyperether.goodjob.resources.new_workspace
import com.hyperether.goodjob.resources.set_up_workspace
import com.hyperether.goodjob.resources.workspace_name
import com.hyperether.goodjob.scenes.components.ErrorDialog
import com.hyperether.goodjob.scenes.register.FullScreenProgressBar
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.theme.RegisterBorder
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun AddNewWorkspaceScreen(
    isMobileView: Boolean,
    workspaceViewModel: WorkspaceViewModel,
    onChooseExistingWorkspace: () -> Unit
) {
    val workspaceName = remember { mutableStateOf("") }
    val workspaceType = remember { mutableStateOf("") }
    val expandedDropdown = remember { mutableStateOf(false) }

    val commonModifier = if (isMobileView) Modifier
        .fillMaxWidth() else
        if (!getPlatformChecker().isMobile() && is4K())
            Modifier.height(56.toScaleDp())
                .width(530.toScaleDp()) else Modifier.width(530.toScaleDp())
            .padding(horizontal = if (isMobileView) 20.toScaleDp() else 0.toScaleDp())

    Column(
        modifier = if (!isMobileView) Modifier
            .fillMaxSize() else Modifier
            .fillMaxSize()
            .padding(16.toScaleDp()),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (isMobileView) {
            Row(
                modifier = Modifier.fillMaxWidth()
            ) {
                HeaderImage(isMobileView, onChooseExistingWorkspace)
                Spacer(modifier = Modifier.width(15.toScaleDp()))
                TitleText(
                    title = if (isMobileView) stringResource(Res.string.new_workspace) else stringResource(
                        Res.string.add_new_workspace
                    ),
                    fontSize = 24.toScaleSp(),
                    lineHeight = 34.toScaleSp(),
                    topPadding = 0,
                    fontWeight = FontWeight.Normal
                )
            }
        } else {
            HeaderImage(isMobileView, null)
            Spacer(modifier = Modifier.height(40.toScaleDp()))
            TitleText(
                title = if (isMobileView) stringResource(Res.string.new_workspace) else stringResource(
                    Res.string.add_new_workspace
                ),
                fontSize = if (isMobileView) 28.toScaleSp() else 40.toScaleSp(),
                topPadding = 0,
                fontWeight = if (isMobileView) FontWeight.Normal else FontWeight.Bold,
                lineHeight = 50.toScaleSp()
            )
        }

        if (!isMobileView) {
            Spacer(modifier = Modifier.height(12.toScaleDp()))
            Text(
                text = stringResource(Res.string.set_up_workspace),
                fontSize = if (!isMobileView) 18.toScaleSp() else 18.toScaleSp(),
                lineHeight = if (!isMobileView) 24.toScaleSp() else 18.toScaleSp(),
                color = DarkGrey,
                textAlign = TextAlign.Center
            )
            if (!isMobileView)
                Spacer(Modifier.height(20.toScaleDp()))
            else
                Spacer(Modifier.height(24.toScaleDp()))
        }

        if (!isMobileView)
            Spacer(Modifier.height(20.toScaleDp()))
        else
            Spacer(Modifier.height(20.toScaleDp()))

        InputField(
            label = stringResource(Res.string.workspace_name),
            placeholder = stringResource(Res.string.enter_workspace_name),
            value = workspaceName.value,
            onValueChange = { workspaceName.value = it },
            modifier = commonModifier
        )

        if (!isMobileView)
            Spacer(Modifier.height(16.toScaleDp()))
        else
            Spacer(Modifier.height(16.toScaleDp()))

//        WorkspaceTypeDropdown(
//            isMobileView = isMobileView,
//            selectedType = workspaceType.value,
//            onTypeSelected = { selectedType ->
//                workspaceType.value = selectedType
//                expandedDropdown.value = false
//            },
//            expanded = expandedDropdown.value,
//            onExpandToggle = { expandedDropdown.value = it },
//            modifier = commonModifier
//        )

//        WorkspaceTypeItem(workspaceType, label = "Workspace Type", placeholder = stringResource(Res.string.choose_category),  listOf("Category 1", "Category 2", "Category 3"))

        if (!isMobileView) {
            Spacer(Modifier.height(32.toScaleDp()))
        } else {
            Spacer(Modifier.height(40.toScaleDp()))
        }

        ActionButton(
            text = stringResource(Res.string.create),
            onClick = {
                workspaceViewModel.showLoader.value = true
                workspaceViewModel.addNewWorkspace(
                    Workspace(
                        name = workspaceName.value,
                        workspaceType = workspaceType.value
                    ),
                    onSuccess = {
                        workspaceViewModel.showLoader.value = false
                        onChooseExistingWorkspace()
                    },
                    onError = { errorMessage ->
                        workspaceViewModel.showLoader.value = false
                        workspaceViewModel.errorText.value = errorMessage
                        workspaceViewModel.showPopUpError.value = true
                    }
                )
            },
            enabled = workspaceName.value.trim().isNotEmpty(),
            modifier = commonModifier.height(56.toScaleDp())
        )
        if (!isMobileView)
            Spacer(Modifier.height(32.toScaleDp()))

//        if (!isMobileView) {
//            ExistingWorkspaceOption(onChooseExistingWorkspace)
//        }

        if (workspaceViewModel.showPopUpError.value) {
            ErrorDialog(
                onDismiss = { workspaceViewModel.showPopUpError.value = false },
                title = stringResource(Res.string.error).uppercase(),
                message = workspaceViewModel.errorText.value
            )
        }
        if (workspaceViewModel.showLoader.value) {
            DisableSelection {
                FullScreenProgressBar()
            }
        }
    }
}

@Composable
fun HeaderImage(isMobileView: Boolean, onChooseExistingWorkspace: (() -> Unit)?) {
    val imageResource = if (isMobileView) Res.drawable.back_arrow else Res.drawable.logo_good_job
    Box(
        modifier = if (!isMobileView) Modifier
            .fillMaxWidth()
            .padding(
                top = 32.toScaleDp(),
                start = 56.toScaleDp()
            ) else Modifier.padding(top = 10.toScaleDp())
            .clickable {
                onChooseExistingWorkspace?.invoke()
            },
        contentAlignment = Alignment.TopStart
    ) {
        Image(
            alignment = Alignment.TopStart,
            painter = painterResource(imageResource),
            contentDescription = null,
            modifier = if (isMobileView) Modifier else
                Modifier
                    .width(145.toScaleDp())
                    .height(38.toScaleDp())
        )
    }
}

@Composable
fun TitleText(
    title: String,
    fontSize: TextUnit,
    lineHeight: TextUnit,
    topPadding: Int,
    fontWeight: FontWeight
) {
    Text(
        text = title,
        fontSize = fontSize,
        lineHeight = lineHeight,
        modifier = Modifier.padding(top = Dp(topPadding.toFloat())),
        fontWeight = fontWeight,
        color = Color.Black
    )
}

@Composable
fun InputField(
    label: String,
    placeholder: String,
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    Row(modifier = modifier.padding(horizontal = 16.toScaleDp())) {
        OutlinedTextField(
            value = value,
            textStyle = TextStyle(fontSize = 16.toScaleSp()),
            onValueChange = onValueChange,
            label = { Text(label, fontSize = 16.toScaleSp()) },
            placeholder = { Text(placeholder, fontSize = 16.toScaleSp()) },
            modifier = modifier,
            singleLine = true,
            shape = if (!isWebMobileView()) RoundedCornerShape(12.toScaleDp()) else RoundedCornerShape(
                0.toScaleDp()
            ),
            colors = if (!isWebMobileView()) TextFieldDefaults.outlinedTextFieldColors(
                focusedLabelColor = InputBorderColor,
                focusedBorderColor = BlueApp,
                unfocusedBorderColor = RegisterBorder,
                disabledTextColor = TextColor,
                placeholderColor = InputBorderColor,
                disabledPlaceholderColor = InputBorderColor
            ) else TextFieldDefaults.outlinedTextFieldColors()
        )
    }
}

@Composable
fun ActionButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    enabled: Boolean
) {
    Button(
        onClick = onClick,
        modifier = modifier,
        shape = RoundedCornerShape(28.toScaleDp()),
        enabled = enabled,
        colors = ButtonDefaults.buttonColors(backgroundColor = Color(0xFF336699))
    ) {
        Text(
            text = text,
            color = Color.White,
            fontSize = 16.toScaleSp(),
            fontWeight = FontWeight.Bold
        )
    }
}

@Composable
fun ExistingWorkspaceOption(onChooseExistingWorkspace: () -> Unit) {
    Divider(
        color = Color.LightGray,
        thickness = 1.toScaleDp(),
        modifier = Modifier.width(530.toScaleDp())
    )
    Spacer(Modifier.height(32.toScaleDp()))
    Text(
        text = stringResource(Res.string.already_have_workspace),
        color = Color.Black,
        fontWeight = FontWeight.W700,
        fontSize = 18.toScaleSp(),
        lineHeight = 22.toScaleSp()
    )
    Spacer(Modifier.height(12.toScaleDp()))
    Text(
        text = stringResource(Res.string.click_here),
        color = BlueApp,
        fontSize = 16.toScaleSp(),
        fontWeight = FontWeight.W400,
        modifier = Modifier.clickable { onChooseExistingWorkspace() },
        textAlign = TextAlign.Center,
    )
}
